const SVG_DATA_URL_PREFIX = 'data:image/svg+xml;charset=utf-8,';

/**
 * Image URL of an icon that comes as URL-encoded SVG markup, like the
 * `iconURL` of a capsule.
 */
export const getSvgDataUrl = (svg: string | undefined) =>
  `${SVG_DATA_URL_PREFIX}${svg ?? ''}`;
